export const PATIENT_TABS = {
  OPEN_TICKETS: 'open_tickets',
  RESOLVED_TICKETS: 'resolved_tickets',
  CALLS: 'calls',
  EPISODES_AND_TASKS: 'episodes_and_tasks'
};

export const TAB_QUERY_PARAM = 'tab';
export const HIGHLIGHT_TICKET_QUERY_PARAM = 'highlight_ticket_id';
